import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-session-confirmation-modal',
  templateUrl: './session-confirmation-modal.component.html',
  styleUrls: ['./session-confirmation-modal.component.scss']
})
export class SessionConfirmationModalComponent implements OnInit {
  title;
  timeLeft: number = 60;
  interval;
  constructor(public dialogRef: MatDialogRef<SessionConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel) {
    this.title = data;
    if (this.title.dialogData.isShow == true) {
      this.startTimer();
    }
  }

  ngOnInit() {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
    this.pauseTimer();
  }

  onDismiss(): void {
    this.dialogRef.close(false);
    this.pauseTimer();
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 60;
      }
    }, 1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }
}

export class ConfirmDialogModel {
  constructor(public dialogData: object) { }
}
